import { useState } from 'react';
import { getId } from 'utils/getId';
import { v4 as uuidv4 } from 'uuid';

// Get deviceId synchronously to avoid race conditions with event logging
const getDeviceId = (): string => {
  try {
    return getId(localStorage, 'deviceId');
  } catch (e) {
    // If localStorage is unavailable, generate a temporary deviceId
    return uuidv4();
  }
};

const useDeviceId = () => {
  // Initialize with the actual deviceId immediately (synchronous)
  const [deviceId] = useState<string>(() => getDeviceId());

  return deviceId;
};

export default useDeviceId;
